import { AfterViewInit, Component } from '@angular/core';
import { WindowRefService } from '../../../../services/window-ref.service';

@Component({
  selector: 'app-trustpilot',
  imports: [],
  templateUrl: './trustpilot.component.html',
  styleUrl: './trustpilot.component.scss',
})
export class TrustpilotComponent implements AfterViewInit {
  private readonly window;
  constructor(private readonly windowRefService: WindowRefService) {
    this.window = windowRefService.nativeWindow;
  }

  ngAfterViewInit(): void {
    const trustboxRef = document.getElementById('trustbox');
    if (trustboxRef && this.window.Trustpilot) {
      this.window.Trustpilot.loadFromElement(trustboxRef);
    }
  }
}
